import { ref, computed, defineComponent } from 'vue';
import { useService } from '@kaokei/use-vue-service';
// import { ScreenMediaService } from '@/services/recordVideo/media.service';
import { RecordVideoService } from '@/services/recordVideo/recordVideo.service';
import StepOne from './coms/stepOne.vue';
import StepTwo from './coms/stepTwo.vue';
export default defineComponent({
  components: {
    StepOne: StepOne,
    StepTwo: StepTwo
  },
  setup: function () {
    // const screenMediaService = useService(ScreenMediaService);
    var recordVideoService = useService(RecordVideoService);
    var steps = computed(function () {
      return recordVideoService.checkStep;
    });
    var currentStepIndex = ref(0);
    var handleStep = function (index) {
      if (index === currentStepIndex.value) return;
      currentStepIndex.value = index;
      // 这里可以添加其他逻辑，比如更新步骤状态等
    };
    var currentStepItem = computed(function () {
      return recordVideoService.checkStep[recordVideoService.currentStepIndex];
    });
    return {
      steps: steps,
      currentStepIndex: currentStepIndex,
      handleStep: handleStep,
      currentStepItem: currentStepItem
    };
  }
});